// src/utils/requests.js
import axios from "axios";
import { Message } from "element-ui";
import router from "@/router";
import { isEmpty } from "@/utils/validate";

axios.defaults.timeout = 40000;
axios.defaults.baseURL = process.env.VUE_APP_PB_URL;
axios.defaults.headers.post["Content-Type"] = "application/json; charset=UTF-8";

const TOKEN_KEY = "pb_token";

function getToken() {
  return localStorage.getItem(TOKEN_KEY) || "";
}

function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

let redirecting = false;
function redirectToLoginOnce() {
  if (redirecting) return;
  redirecting = true;

  const cur = router.currentRoute || {};
  if (cur.path !== "/login") {
    router
      .replace({ path: "/login", query: { redirect: cur.fullPath || "/analysis" } })
      .finally(() => {
        redirecting = false;
      });
  } else {
    redirecting = false;
  }
}

axios.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const status = error?.response?.status;

    if (status === 401 || status === 403) {
      clearToken();
      redirectToLoginOnce();
    }

    const msg =
      error?.response?.data?.message ||
      error?.message ||
      "Request failed";

    Message({
      message: msg,
      type: "error",
      duration: 5 * 1000,
    });

    return Promise.reject(error);
  }
);

export default {
  get(url, params = {}, config = {}) {
    return axios.get(url, { params, ...config });
  },

  post(url, data = {}, contentType, config = {}) {
    const headers = { ...(config.headers || {}) };

    if (!isEmpty(contentType)) {
      headers["Content-Type"] = contentType;
    }

    return axios.post(url, data, {
      ...config,
      headers,
    });
  },

  patch(url, data = {}, contentType, config = {}) {
    const headers = { ...(config.headers || {}) };

    if (!isEmpty(contentType)) {
      headers["Content-Type"] = contentType;
    }

    return axios.patch(url, data, {
      ...config,
      headers,
    });
  },

  delete(url, params = {}, config = {}) {
    return axios.delete(url, {
      params,
      ...config,
    });
  },
};